import { getTelemetryClientConfig } from '@ms/yammer-telemetry-store';
import { acquireTokenWithoutTelemetry } from '@ms/yammer-web-authenticators';

export type GetAuthToken = () => Promise<string | null>;
export const getAuthToken: GetAuthToken = async () => {
  const clientConfig = getTelemetryClientConfig();
  if (!clientConfig) {
    return null;
  }

  try {
    return await acquireTokenWithoutTelemetry({ scopes: [clientConfig.resource] });
  } catch {
    return null;
  }
};
